module.exports = __webpack_public_path__ + "img/technician.30fdec8f.svg";